import React from 'react';
import { FormikValues } from 'formik';
import DataForm from '../../components/DataForm';
import { FormHelpers } from '../../components/Form/Form';
import { api } from '../../hooks/api.hooks';
import { useAuthentication } from '../../state/Authentication';
import { updateUser } from '../../state/Authentication/actions';
import { useDomainSchema } from './hooks';

interface PreferenceDomainProps {
  schema: Api.Domain;
}

const PreferenceDomain: React.FC<PreferenceDomainProps> = ({ schema }) => {
  const { dispatch } = useAuthentication();
  const { data, humanReadableData, renderForm, validationSchema } = useDomainSchema(schema);

  const handleSubmit = React.useCallback(
    async (values: any, { setFieldError }: FormHelpers) => {
      try {
        const { data: domain } = await api.patch<Api.UserDomain>(`/me/${schema.key}`, {
          preferences: values,
        });

        dispatch(updateUser({ domains: { [schema.key]: domain } }));
      } catch (e) {
        setFieldError('', 'error.server.unknown');
      }
    },
    [schema],
  );

  return (
    <DataForm
      onSubmit={handleSubmit}
      initialValues={data as FormikValues}
      data={humanReadableData}
      validationSchema={validationSchema}
      domain={schema}
    >
      {renderForm()}
    </DataForm>
  );
};

export default PreferenceDomain;
